import { axios } from '@/services/axios';

/**
 * Trunk types that can be created on a company.
 *
 * Platform-agnostic — prefer this over the per-service
 * `/Services/{Type}/Company/{id}/TrunkTypes/Available` endpoints, which list
 * what may be assigned to that service's definition rather than what a user
 * can create.
 */
const getTrunkTypesForCompany = async (companyId) => {
    const result = await axios.get(
        `/Company/${companyId}/TrunkTypes/Available`,
    );
    return result;
};

export default getTrunkTypesForCompany;
